import { Component, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { SegurosApiService } from '../../../comun/services/api/seguros-api.service';
import { CaFormFieldComponent, CaIcon, CaLabel } from '@global-front-components/ui/form-field';
import { CaInputDirective } from '@global-front-components/ui/input';
import { CaTabComponent, CaTabGroupComponent } from '@global-front-components/ui/tabs';
import { CaButtonComponent } from '@global-front-components/ui/button';
import { TranslateModule } from '@ngx-translate/core';
import { CaCardComponent } from '@global-front-components/ui/card';
import { DateUtilsService } from '../../../comun/services/util/date-utils.service';
import { ActivatedRoute } from '@angular/router';
import { DatosClienteComponent } from '../../components/datos-cliente/datos-cliente.component';
import { DatosAseguradosComponent } from '../../components/datos-asegurados/datos-asegurados.component';
import { DatosSolicitudEstadosComponent } from '../../../comun/components/datos-solicitud-estados/datos-solicitud-estados.component';
import { AuthStoreService } from '../../../comun/services/store/auth-store.service';
import { Solicitud, SolicitudPoliza } from '../../../comun/model/solicitud.model';
import { PolizaSalud } from '../../../comun/model/salud.model';

@Component({
	standalone: true,
	imports: [
		CommonModule, 
		CaLabel,
		CaFormFieldComponent,
		CaInputDirective,    
		CaTabComponent,
		CaTabGroupComponent,
		CaButtonComponent,
		CaIcon,
		CaCardComponent,
		DatosClienteComponent,
		DatosAseguradosComponent,
		DatosSolicitudEstadosComponent,
		TranslateModule
	],
	templateUrl: './datos-solicitud.view.html',
	styleUrls: ['./datos-solicitud.view.scss']
})
export class DatosSolicitudView implements OnInit{
	public solicitud: Solicitud;
	public solicitudPoliza: SolicitudPoliza<PolizaSalud>;

	constructor(
		private activatedRoute: ActivatedRoute,
		private segurosService: SegurosApiService,
		private authStoreService: AuthStoreService,
		private dateUtil: DateUtilsService,
		private location: Location,
	){}

	ngOnInit(): void {
		this.activatedRoute.queryParams.subscribe(params => {
			let nombreAgente = this.authStoreService.getUsuarioActivo();
			this.solicitud = {
				nombreAgente: nombreAgente,
				codigoColectiva: params['colectiva'] || '',
				codigoCertificado: Number(params['certificado']) || 0,
				codigoEstado: params['estado'] || '',
				numeroMovimiento: params['numMovimiento'] || '',
				tipoSolicitud: params['tipoSolicitud'] || ''
			};

			if (this.solicitud) {
				this.segurosService.getDatosSolicitudSalud(this.solicitud).subscribe(solicitudPoliza => {
					this.solicitudPoliza = solicitudPoliza;
				});
			}
		});
	}

	mostrarFecha(date: string | null): string {
		return this.dateUtil.formatearFecha(date);
	}

	volver(): void {
		this.location.back();
	}

	duplicado(): void {
		this.segurosService.getDuplicado(this.solicitud.codigoColectiva, this.solicitud.codigoCertificado)
        .subscribe((url: string) => {
            if (url) {
                window.open(url, '_blank');
            }
        });
	}
	
}
